import { Visibility } from "@mui/icons-material";
import { Typography } from "@mui/material";
import moment from "moment";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import {
  clearNotificacion,
  getNotificacion,
  getNotificacionesYCitas,
  marcarNotificacionLeida,
} from "../../../../../../redux/actions/notificacion";
import PdfDialog from "../../../../../commons/file/PdfDialog";
import { StyledNotificaciones } from "../../../../../styled/ExamenesPeriodicos";

const NotificacionesCard = ({ data, idSiniestroCabecera }) => {
  const dispatch = useDispatch();

  const notificacionRedux = useSelector((state) => state.notificacion);

  const [openNotificacionPdf, setOpenNotificacionPdf] = useState(false);
  const [notificacionSeleccionada, setNotificacionSeleccionada] =
    useState(null);

  const handleOpenDetail = (notificacion) => {
    setOpenNotificacionPdf(true);
    setNotificacionSeleccionada(notificacion);
    dispatch(getNotificacion(notificacion.idNotificacionFehaciente));
  };

  const handleClose = () => {
    setOpenNotificacionPdf(false);
    setNotificacionSeleccionada(null);
    dispatch(clearNotificacion());
    dispatch(getNotificacionesYCitas(idSiniestroCabecera));
  };

  const sendNotificacion = () => {
    dispatch(
      marcarNotificacionLeida(notificacionSeleccionada.idNotificacionFehaciente)
    ).then(() => toast.success("Notificación leída"));
  };

  return (
    <>
      <div>
        {data.length ? (
          data.map((notificacion) => {
            return (
              <StyledNotificaciones.Card
                key={notificacion.idNotificacionFehacienteSiniestroCabecera}
              >
                <div style={{ width: 350 }}>
                  <Typography variant="body2" style={{ color: "grey" }}>
                    {moment(notificacion.fecha).format("DD/MM/YYYY")}
                  </Typography>
                  <Typography variant="body2">
                    {notificacion.tipoNotificacion}
                  </Typography>
                </div>
                <StyledNotificaciones.ActionsContainer>
                  <StyledNotificaciones.Button
                    title={"Ver notificación"}
                    onClick={() => handleOpenDetail(notificacion)}
                  >
                    <Visibility />
                  </StyledNotificaciones.Button>
                </StyledNotificaciones.ActionsContainer>
              </StyledNotificaciones.Card>
            );
          })
        ) : (
          <StyledNotificaciones.EmptyState variant="body2">
            No hay notificaciones disponibles para mostrar
          </StyledNotificaciones.EmptyState>
        )}
      </div>
      <div>
        <PdfDialog
          open={
            openNotificacionPdf && notificacionRedux.notificacion.data.base64
              ? true
              : false
          }
          title="Notificación"
          handleClose={handleClose}
          controllers={true}
          file={notificacionRedux.notificacion.data.base64}
          sendNotificacion={sendNotificacion}
        />
      </div>
    </>
  );
};

export default NotificacionesCard;
